import { Component, OnInit, EventEmitter, OnChanges, Input, Output, ViewEncapsulation, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, AbstractControl } from '@angular/forms';
import { IView, ICAMLFilter, IFilterInput, ILookup } from '../common/models';
import { ListService } from './ListService';
import $ from 'jquery';
import { IField } from '../common/models';
import { CAMLFilter } from './camlFilter';
import { ODataFilter } from './odataFilter';
import { IXFilter } from './IXFilter';
import { Observable } from 'rxjs';

@Component({
  selector: 'spx-datafilter',
  template: `<div class="spx-calendardatafilter">
    <form novalidate [formGroup]='dataFilter'>
        <div class='panel'>

            <div class="p-3 bg-light mb-3">
                <label class="font-14 mb-3">Filter Data</label>
                <!-- old -->
                <!-- <div class="d-flex align-items-center mb-3" id="multicolumn">
                    <div class="custom-control custom-radio mr-3">
                        <input type="radio" id="show-all-filter" value="all" formControlName="filterType"
                            (ngModelChange)='onFilterTypeChange($event)' name="filterType"
                            [checked]="dataFilter.get('filterType').value === 'all'" class="custom-control-input">
                        <label class="custom-control-label font-14" for="show-all-filter">Show All</label>
                    </div>
                    <div class="custom-control custom-radio mr-3">
                        <input type="radio" id="existing-list-filter" value="view" formControlName="filterType"
                            (ngModelChange)='onFilterTypeChange($event)' name="filterType"
                            [checked]="dataFilter.get('filterType').value === 'view'" class="custom-control-input">
                        <label class="custom-control-label font-14" for="existing-list-filter">Use Existing List
                            View</label>
                    </div>
                    <div class="custom-control custom-radio mr-3">
                        <input type="radio" id="specify-condition-filter" value="filter" formControlName="filterType"
                            (ngModelChange)='onFilterTypeChange($event)' name="filterType"
                            [checked]="dataFilter.get('filterType').value === 'filter'" class="custom-control-input">
                        <label class="custom-control-label font-14" for="specify-condition-filter">Specify Filter
                            Condition</label>
                    </div>
                </div> -->
                <!-- new -->
                <div class="d-flex align-items-center mb-3" id="multicolumn">
                    <div id="multicolumn">
                        <span style='width: 100px'><input style='margin:0px' type="radio" value="all" formControlName="filterType" (ngModelChange)='onFilterTypeChange($event)'
                            name="filterType" [checked]="dataFilter.get('filterType').value === 'all'"> Show All</span> 
                        <span style='width: 180px'><input style='margin:0px;' type="radio" value="view" formControlName="filterType" (ngModelChange)='onFilterTypeChange($event)' 
                            name="filterType"  [checked]="dataFilter.get('filterType').value === 'view'"> Use Existing List View</span>            
                        <span><input style='margin:0px' type="radio" value="filter" formControlName="filterType" (ngModelChange)='onFilterTypeChange($event)'
                            name="filterType" [checked]="dataFilter.get('filterType').value === 'filter'"> Specify Filter Condition</span>            
                    </div>
                </div>
                <div *ngIf="dataFilter.get('filterType').value === 'filter'">
                    <div formArrayName="filters">
                        <div *ngFor="let filter of getFilters(); let i = index" class="panel" style='padding-left: 20px;
                        padding-top: 15px;padding-right: 5px;'>
                            <div [formGroupName]="i">
                                <div class="row no-gutters align-items-center mb-3">
                                    <div class="col pr-2">
                                        <select class="form-control" formControlName='field'
                                            (change)="onFieldChange($event, i)">
                                            <option *ngFor='let f of fields' [ngValue]='f'>{{f.title || f.Title}}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col pt-1 pr-2">
                                        <select class="form-control" formControlName='operator'>
                                            <option *ngFor='let o of ops' [ngValue]='o' >{{o}}</option>
                                        </select>
                                    </div>
                                    <div class="col pt-1 pr-2">
                                        <input *ngIf='!isLookupOrUserType(i)' class="filterValue" type="text"
                                            formControlName="value">
                                        <select *ngIf='isLookupOrUserType(i)' class="form-control"
                                            formControlName='value'>
                                            <!-- <option [ngValue]= "" [selected]="true">Select Operator</option> -->
                                            <option *ngFor='let o of lookupValues[i]' [ngValue]='o'>{{o.value}}</option>
                                        </select>
                                    </div>
                                    <div class="col-auto pt-2">
                                        <a href="#" class="close-icon" *ngIf="getFiltersLength() > 1"
                                            (click)="removeFilter(i)">X</a>
                                    </div>
                                </div>
                                <div class="row no-gutters align-items-center mb-3">
                                    <div class="col-auto px-2 conditionContainer" *ngIf="getFiltersLength() != (i+1)">
                                        <select formControlName='logicalOp' class="form-control">
                                            <option value="'And'" [ngValue]="AndOp">And</option>
                                            <option value="'Or'" [ngValue]="OrOp">Or</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <a (click)="addFilter()" class="text-dark font-14" style="cursor: pointer">
                            <span class="k-icon k-i-plus-outline filterIcon"></span>
                            <span class="filterContainer">Add Filter Condition</span>
                        </a>
                    </div>
                </div>
                <!-- list of filters -->
                <div *ngIf="dataFilter.get('filterType').value === 'view'" class="panel">
                    <div class="row">
                        <div class="col viewContainer">
                            <div class="form-group">
                                <label class="font-14">Select a View</label>
                                <div class="clearfix">
                                    <select class="form-control" formControlName='view'>
                                        <option *ngFor='let view of views' [ngValue]='view'>{{view.title || view.Title}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
`,
  styles: [`.spx-calendardatafilter select,.spx-calendardatafilter textarea{font:400 16px/1.4 "Helvetica Neue",Helvetica,Arial,sans-serif;color:#444;letter-spacing:.5px;-webkit-font-smoothing:antialiased;box-sizing:border-box}.spx-calendardatafilter #multicolumn{display:table;width:100%}.spx-calendardatafilter #multicolumn>span{display:table-cell;width:33.33%}.spx-calendardatafilter .panel{color:#333;overflow:hidden}.spx-calendardatafilter .panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.spx-calendardatafilter .col3{width:33%;float:left;position:relative;min-height:1px;padding-right:15px;padding-left:15px}.spx-calendardatafilter .col3Center{width:22%;position:relative;min-height:1px;padding-right:15px;padding-left:15px;margin:auto}.spx-calendardatafilter .datepicker{width:33%;float:left;position:relative;min-height:1px;padding-right:15px;padding-left:15px;height:50px;font-size:17px}.spx-calendardatafilter *{box-sizing:border-box;-webkit-box-sizing:border-box;-moz-box-sizing:border-box}.spx-calendardatafilter .error{font-size:14px;color:#c7254e;background:#f9f2f4;border-radius:0;padding:15px;margin:-26px 0 15px}.spx-calendardatafilter .block{display:block;margin:0 0 10px}.spx-calendardatafilter .filterValue,.spx-calendardatafilter select{height:32px!important;outline:0;width:100%;padding:0 15px 2px;font-size:17px;background:#fff;border:1px solid #8a8886!important}.spx-calendardatafilter .filterValue:focus,.spx-calendardatafilter select:focus{outline:0}.spx-calendardatafilter textarea{outline:0;width:100%;margin-bottom:25px;padding:0 15px 2px;font-size:17px;background:#fff;border:2px solid #ebebeb;border-radius:0;box-shadow:inset 0 -2px #ebebeb}.spx-calendardatafilter textarea:focus{border-color:#62c2e4;outline:0;box-shadow:inset 0 -2px #62c2e4}.viewContainer{margin-right:10px!important;margin-left:10px!important;margin-top:5px!important}.conditionContainer{padding-left:0!important}.filterContainer{margin-left:5px!important;color:var(--theme-color)!important}.filterIcon{margin-top:-3px!important;color:var(--theme-color)!important}`],
  providers: [ListService],
  encapsulation: ViewEncapsulation.None
})
export class SPXDataFilterComponent implements OnInit, OnChanges {

  public ops: String[];
  public dataFilter: FormGroup;

  public fields: IField[];
  public views: IView[];
  public lookupValues: Array<ILookup[]> = [];

  @Input()
  public type: string;

  @Input()
  public themePrimary: string = '#0078d4';

  @Input('input')
  public input: IFilterInput;
  @Output()
  valueChange = new EventEmitter<string>(true);

  private filterUtility: IXFilter;
  themeColor: string;
  public AndOp = 'And';
  public OrOp = 'OR';
  constructor(private fb: FormBuilder, private service: ListService) {
    this.dataFilter = this.fb.group({
      filterType: ['all', Validators.required],
      view: ['', Validators.required],
      filters: this.fb.array([
        this.initFilter()
      ])
    });
  }

  ngOnInit() {
    this.themeColor = this.themePrimary;
    document.documentElement.style.setProperty('--theme-color', this.themeColor);
    this.dataFilter.valueChanges.subscribe(data => {
      const sch = this.generateFilterData(data);
      this.valueChange.emit(sch);
    });
  }

  initFilter() {
    // initialize our filters
    return this.fb.group({
      field: ['', Validators.required],
      operator: [''],
      value: [''],
      logicalOp: ['', Validators.required]
    });

  }

  addFilter() {
    // add address to the list
    const control = <FormArray>this.dataFilter.controls['filters'];
    control.push(this.initFilter());
  }

  removeFilter(i: number) {
    // remove address from the list
    const control = <FormArray>this.dataFilter.controls['filters'];
    control.removeAt(i);
  }

  getFilters() {
    return ((<FormArray>this.dataFilter.get('filters')).controls);
  }

  onFieldChange(event, i: number) {
    const fieldType = this.getFieldType(i);
    this.lookupValues[i] = [];
    if (fieldType === 'Lookup' || fieldType === 'LookupMulti') {
      this.fillLookupValues(i).subscribe((r) => {
        const filterControl: FormGroup = <FormGroup>(<FormArray>this.dataFilter.controls['filters']).at(i);
        filterControl.controls['value'].setValue(this.lookupValues[i][0]);
      });
    } else if (fieldType === 'User' || fieldType === 'UserMulti') {
      this.fillUserValues(i).subscribe((a) => {
        const filterControl: FormGroup = <FormGroup>(<FormArray>this.dataFilter.controls['filters']).at(i);
        filterControl.controls['value'].setValue(this.lookupValues[i][0]);
      });
    } else {
      const filterControl: FormGroup = <FormGroup>(<FormArray>this.dataFilter.controls['filters']).at(i);
      filterControl.controls['value'].setValue('');
    }
    return;
  }

  fillLookupValues(i: number) {
    return new Observable<boolean>((obsr) => {
      const name = this.getField(i).InternalName || this.getField(i).internalName;
      this.service.getLookupValues(this.input.webUrl, this.input.listName, name).subscribe(data => {
        const temp: Array<ILookup> = [];
        temp.push(this.filterUtility.generateDefaultValue());
        // Sort on title
        data.sort((a, b) => {
          if (a.Title < b.Title) { return -1; }
          if (a.Title > b.Title) { return 1; }
          return 0;
        });
        data.forEach(el => {
          temp.push({ value: el.Title, id: el.Id });
        });
        // To keep distinct elements
        const result = [];
        const map = new Map();
        for (const item of temp) {
          if (!map.has(item.id)) {
            map.set(item.id, true);    // set any value to Map
            result.push(item);
          }
        }
        this.lookupValues[i] = result;
        obsr.next(true);
        obsr.complete();
      });
    });
  }

  fillUserValues(i: number) {
    return new Observable<boolean>(obsr => {
      this.service.getUserValues(this.input.webUrl).subscribe((data: any) => {
        const temp: Array<ILookup> = [];
        temp.push(this.filterUtility.generateDefaultValue());
        data.d.results.forEach(el => {
          temp.push({ value: el.Title, id: el.Id });
        });
        this.lookupValues[i] = temp;
        obsr.next(true);
        obsr.complete();
      });
    });
  }

  getFieldType(i: number): string {
    let fld = (<FormGroup>(<FormArray>this.dataFilter.get('filters')).at(i)).controls['field'].value.type;
    fld = fld || (<FormGroup>(<FormArray>this.dataFilter.get('filters')).at(i)).controls['field'].value.Type;
    return fld;
  }

  getField(i: number): IField {
    return (<FormGroup>(<FormArray>this.dataFilter.get('filters')).at(i)).controls['field'].value;
  }

  // isDateTimeField(i: number) {
  //   return this.getFieldType(i) === 'DateTime';
  // }

  isLookupOrUserType(i: number) {
    return this.getFieldType(i) === 'Lookup' || this.getFieldType(i) === 'LookupMulti' ||
      this.getFieldType(i) === 'User' || this.getFieldType(i) === 'UserMulti';
  }

  generateFilterData(data: any): any {
    if (!data) {
      return '';
    }

    let query;
    switch (data.filterType) {
      case 'filter':
        if (this.type === 'caml') {
          query = { camlFilter: this.filterUtility.generateFilter(data), filters: this.dataFilter.value.filters };
        } else {
          query = { odataFilter: this.filterUtility.generateFilter(data), filters: this.dataFilter.value.filters };
        }
        break;
      case 'view':
        query = this.generateViewFilter(data);
        break;
      default:
        query = '';
        break;
    }
    return { query: query, filterType: data.filterType };
  }

  getFiltersLength() {
    return (<FormArray>this.dataFilter.get('filters')).length;
  }

  generateViewFilter(data: any): any {
    return this.filterUtility.generateViewFilter(data);
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes.type) {
      this.filterUtility = this.type === 'caml' ? new CAMLFilter() : new ODataFilter();
      this.ops = this.filterUtility.getFilterOperations();
    }
    if (this.input &&
      this.input.webUrl && this.input.listName) {

      const validInput = this.input;
      const fType = validInput.filterType || 'all';
      this.dataFilter.get('filterType').setValue(fType,
        { onlySelf: true, emitEvent: false, emitViewToModelChange: false });

      if (validInput.filterType === 'filter') {
        this.fields = [this.filterUtility.generateDefaultField()];
        this.service.getFields(validInput.webUrl, validInput.listName)
          .subscribe((data) => {
            const temp = (<any>data).d.results;
            temp.sort((a, b) => {
              if (a.Title < b.Title) { return -1; }
              if (a.Title > b.Title) { return 1; }
              return 0;
            });
            temp.forEach(e => {
              this.fields.push(this.filterUtility.generateField(e));
            });
            this.setInitFilter(validInput);
          });
      }

      if (validInput.filterType === 'view') {
        this.views = [this.filterUtility.generateDefaultView()];
        this.service.getViews(validInput.webUrl, validInput.listName)
          .subscribe((data) => {
            const temp = (<any>data).d.results;
            temp.sort((a, b) => {
              if (a.Title < b.Title) { return -1; }
              if (a.Title > b.Title) { return 1; }
              return 0;
            });
            temp.forEach(e => {
              this.views.push(this.filterUtility.generateViewObject(e));
            });
            this.setInitView(validInput);
          });
      }
    }
  }

  private setInitView(validInput: any) {
    const view = this.views.find(v => v.query === <string>validInput.query || v.ListViewXml === <string>validInput.query) || this.views[0];
    this.dataFilter.get('view').setValue(view, { onlySelf: true, emitEvent: false, emitViewToModelChange: false });
  }

  private setInitFilter(validInput: any) {
    if (validInput.query && this.filterUtility.getFilterObject(validInput.query)) {
      const filterArray: FormArray = <FormArray>this.dataFilter.controls['filters'];
      const filters: Array<any> = this.filterUtility.getFilterObject(validInput.query);
      for (let i = 0; i < filters.length; i++) {
        let filterControl: FormGroup = <FormGroup>(<FormArray>this.dataFilter.controls['filters']).at(i);
        if (!filterControl) {
          this.addFilter();
          filterControl = <FormGroup>(<FormArray>this.dataFilter.controls['filters']).at(i);
        }
        const filter = filters[i];

        let fld: IField;
        if (filter.field.internalName) {
          fld = this.fields.find(f => f.internalName === filter.field.internalName);
        } else if (filter.field.InternalName) {
          fld = this.fields.find(f => f.InternalName === filter.field.InternalName);
        } else {
          fld = this.fields[0];
        }

        filterControl.controls['field'].setValue(fld, { onlySelf: true, emitEvent: false, emitViewToModelChange: false });

        const op = this.ops.find(f => f === filter.operator) || this.ops[0];
        filterControl.controls['operator'].setValue(op, { onlySelf: true, emitEvent: false, emitViewToModelChange: false });
        if (filter.logicalOp) {
          filterControl.controls['logicalOp']
            .setValue(filter.logicalOp, { onlySelf: true, emitEvent: false, emitViewToModelChange: false });
        }
        const fldType = fld.Type || fld.type;
        if (fldType === 'User' || fldType === 'UserMulti') {
          this.fillUserValues(i).subscribe((a) => {
            const v = this.lookupValues[i].find(f => f.id === filter.value.id);
            filterControl.controls['value'].setValue(v); // Have to emit value here to set the settings
          });
        } else if (fldType === 'Lookup' || fldType === 'LookupMulti') {
          this.fillLookupValues(i).subscribe((a) => {
            const v = this.lookupValues[i].find(f => f.id === filter.value.id);
            filterControl.controls['value'].setValue(v); // Have to emit value here to set the settings
          });
        } else {
          filterControl.controls['value'].setValue(filter.value); // Have to emit value here to set the settings
        }
      }
    } else {
      const filterControl: FormGroup = <FormGroup>(<FormArray>this.dataFilter.controls['filters']).at(0);
      filterControl.controls['field'].setValue(this.fields[0], { onlySelf: true, emitEvent: false, emitViewToModelChange: false });

      filterControl.controls['operator'].setValue(this.ops[0], { onlySelf: true, emitEvent: false, emitViewToModelChange: false });
    }

  }

  onFilterTypeChange(fType) {
    if (this.input &&
      this.input.webUrl && this.input.listName) {

      const validInput = this.input;

      switch (fType) {
        case 'filter':
          this.fields = [this.filterUtility.generateDefaultField()];
          this.service.getFields(validInput.webUrl, validInput.listName)
            .subscribe((data) => {
              const temp = (<any>data).d.results;
              temp.sort((a, b) => {
                if (a.Title < b.Title) { return -1; }
                if (a.Title > b.Title) { return 1; }
                return 0;
              });
              temp.forEach(e => {
                this.fields.push(this.filterUtility.generateField(e));
              });
              this.setInitFilter(validInput);
            });
          break;
        case 'view':
          this.views = [this.filterUtility.generateDefaultView()];
          this.service.getViews(validInput.webUrl, validInput.listName)
            .subscribe((data) => {
              const temp = (<any>data).d.results;
              temp.sort((a, b) => {
                if (a.Title < b.Title) { return -1; }
                if (a.Title > b.Title) { return 1; }
                return 0;
              });
              temp.forEach(e => {
                this.views.push(this.filterUtility.generateViewObject(e));
              });
              this.setInitView(validInput);
            });
          break;
        default:
          break;
      }
    }
  }

}
